export default {
    data() {
        return {
            userType:'',//0:未付费用户 1:试用账户 2:付费用户,
            sUserRole:'',// 子账户权限 1:房企拿地监控 2:房企项目 3:全装修 4:招标采购 5:研究报告 6:我的业绩
            sUid:'',//用户id
        }
    },
    computed: {
        // 判断是不是大屏用户（此处通过用户id判断）
        isScreen(){
            return this.sUid == 8706 ? true : false
        }
    },
    created() {
        this.userType=localStorage.getItem('sZfyxType')
        if(localStorage.getItem('sZfyxRole')){
            this.sUserRole= localStorage.getItem('sZfyxRole').split(',').map(Number);
        }
        if(localStorage.getItem('sZfyxUid')){
            this.sUid= localStorage.getItem('sZfyxUid');
        }
        
    },
    methods:{
        showTip(){
            this.$message({
                message: '您不是VIP会员，无查看权限。购买咨询：010-68002661',
                type: 'warning'
            });
        }
    },
}